import { Button } from 'foundations-components/transitional/components/Button';
import { connect } from 'react-redux';
// @ts-expect-error types missing
import { convertForm } from 'FormsUI/actions/CollectedForms';
// @ts-expect-error types missing
import { getRequestState } from 'FormsUI/selectors/CollectedForms';
import { hasFormsWriteAccess as hasFormsWriteAccessFromSelector } from 'FormsUI/selectors/Scope';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
// @ts-expect-error types missing
import withPermissionsTooltip from 'FormsCommonComponents/withPermissionsTooltip';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { H2 } from 'foundations-components/transitional/components/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PermissionedUIButton = withPermissionsTooltip(Button);
const ConvertCollectedFormDialog = ({
  guid,
  currentFolderId,
  onClose,
  requestState,
  hasFormsWriteAccess,
  disabled = false,
  convert
}) => {
  const handleConvertCollectedForm = () => {
    trackDashboardInteraction('convert-collected-form');
    convert(guid, currentFolderId);
  };
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "convert-form-dialog",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose()
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'collectedFormConverter.dialog.header'
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'collectedFormConverter.dialog.body'
        })
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(PermissionedUIButton, {
        use: "primary",
        disabled: disabled || requestState.isPending(),
        onClick: handleConvertCollectedForm,
        hasPermission: hasFormsWriteAccess,
        "data-test-id": "confirm-convert-collected-form",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'collectedFormConverter.dialog.confirm'
        })
      })
    })]
  });
};
const mapStateToProps = state => ({
  requestState: getRequestState(state),
  hasFormsWriteAccess: hasFormsWriteAccessFromSelector(state)
});
const actionsToBind = {
  convert: convertForm
};
export default connect(mapStateToProps, actionsToBind)(ConvertCollectedFormDialog);